module.exports = "uniform vec3 glowColor;\nvarying float intensity;\nuniform float opacity;\nvoid main() {\n\tvec3 glow = glowColor * intensity;\n    // gl_FragColor = vec4( glow, opacity );\n    gl_FragColor = vec4( glow, clamp((1.0 - intensity) * opacity, 0.0, 1.0) );\n    // gl_FragColor = vec4( glow, clamp((1.0 - intensity) * opacity * 2.0, 0.0, 1.0) );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/Key3D/WoozyShaders/Glow.frag
// module id = 535
// module chunks = 0